export default __webpack_public_path__ + "static/media/gallery_08.fca70fe7.jpg";